/* Pawley House – storefront behaviours (size assistant, hero, delivery estimate, FAQ tabs, cart tiers) */
(function () {
  'use strict';
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  /* ---------------- Money ---------------- */
  function money(cents) {
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    try { return new Intl.NumberFormat('en-US', { style: 'currency', currency: cur }).format(cents / 100); }
    catch (e) { return '$' + (cents / 100).toFixed(2); }
  }

  /* ---------------- Delivery estimate ---------------- */
  function addBusinessDays(d, n) {
    var r = new Date(d.getTime());
    while (n > 0) { r.setDate(r.getDate() + 1); var w = r.getDay(); if (w !== 0 && w !== 6) n--; }
    return r;
  }
  function fmt(d) { return d.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' }); }
  function initDelivery() {
    $$('[data-ph-delivery]').forEach(function (el) {
      var now = new Date();
      var min = parseInt(el.dataset.min || 4, 10), max = parseInt(el.dataset.max || 6, 10);
      var out = $('[data-ph-delivery-range]', el);
      if (out) out.textContent = fmt(addBusinessDays(now, min)) + ' – ' + fmt(addBusinessDays(now, max));
    });
  }

  /* ---------------- Hero rotation ---------------- */
  function initHero() {
    $$('[data-ph-hero]').forEach(function (hero) {
      var isMobile = window.matchMedia('(max-width: 768px)').matches;
      var set = $(isMobile ? '[data-ph-hero-mobile]' : '[data-ph-hero-desktop]', hero) || $('[data-ph-hero-desktop]', hero);
      if (!set) return;
      $$('[data-ph-hero-desktop],[data-ph-hero-mobile]', hero).forEach(function (s) { if (s !== set) s.remove(); });
      set.hidden = false;
      var clips = $$('video', set);
      var dots = $$('.ph-hero__dots span', hero);
      if (!clips.length) return;
      var i = 0;
      clips.forEach(function (v) { v.muted = true; v.playsInline = true; v.preload = 'auto'; if (v.dataset.src) { v.src = v.dataset.src; } });
      function show(n) {
        clips.forEach(function (v, k) { v.classList.toggle('is-active', k === n); if (k !== n) { try { v.pause(); } catch (e) {} } });
        dots.forEach(function (d, k) { d.classList.toggle('is-active', k === n); });
        var v = clips[n]; try { v.currentTime = 0; var p = v.play(); if (p && p.catch) p.catch(function () {}); } catch (e) {}
      }
      clips.forEach(function (v, k) { v.addEventListener('ended', function () { if (k === i) { i = (i + 1) % clips.length; show(i); } }); });
      show(0);
      var poster = $('.ph-hero__poster', hero);
      if (poster) setTimeout(function () { poster.classList.remove('is-active'); }, 400);
    });
  }

  /* ---------------- FAQ tabs ---------------- */
  function initFaq() {
    $$('[data-ph-faq]').forEach(function (faq) {
      var tabs = $$('.ph-faq__tab', faq), panels = $$('.ph-faq__panel', faq);
      tabs.forEach(function (t, k) {
        t.addEventListener('click', function () {
          tabs.forEach(function (x) { x.classList.remove('is-active'); x.setAttribute('aria-selected', 'false'); });
          panels.forEach(function (p) { p.classList.remove('is-active'); });
          t.classList.add('is-active'); t.setAttribute('aria-selected', 'true');
          if (panels[k]) panels[k].classList.add('is-active');
        });
      });
    });
  }

  /* ---------------- Size assistant ---------------- */
  var ORDER = ['XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL', 'XXXL', '4XL', '5XL', '6XL', '7XL'];
  function norm(s) { s = String(s).toUpperCase().replace(/\s+/g, ''); if (s === '2XS') return 'XXS'; if (s === '2XL') return 'XXL'; if (s === '3XL') return 'XXXL'; return s; }

  function initSizeAssistant() {
    var m = $('#PhSizeAssistant');
    if (!m || m.dataset.ready) return;
    m.dataset.ready = '1';
    var gender = m.dataset.gender, cat = m.dataset.cat;
    var sizes = []; try { sizes = JSON.parse(m.dataset.sizes || '[]'); } catch (e) {}
    var steps = $$('.ph-sa__step', m).filter(function (s) { return s.dataset.step !== 'result'; });
    var result = $('.ph-sa__step[data-step="result"]', m);
    var nav = $('[data-ph-sa-nav]', m), back = $('[data-ph-sa-back]', m), next = $('[data-ph-sa-next]', m);
    var bar = $('[data-ph-sa-progress]', m);
    var cur = 0, unit = 'us', answers = {}, rec = null;

    function open() { m.classList.add('is-open'); document.documentElement.style.overflow = 'hidden'; }
    function close() { m.classList.remove('is-open'); document.documentElement.style.overflow = ''; }
    function go(n) {
      cur = n;
      steps.forEach(function (s, k) { s.classList.toggle('is-active', k === n); });
      result.classList.remove('is-active');
      nav.hidden = false; back.hidden = n === 0;
      next.textContent = n === steps.length - 1 ? 'Show my size' : 'Continue';
      bar.style.width = Math.round(((n + 1) / (steps.length + 1)) * 100) + '%';
    }
    function err(msg) { var e = $('[data-ph-sa-err]', steps[cur]); if (e) e.textContent = msg || ''; }

    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-ph-size-open]')) { e.preventDefault(); open(); }
    });
    $$('[data-ph-sa-close]', m).forEach(function (b) { b.addEventListener('click', close); });
    m.addEventListener('click', function (e) { if (e.target === m) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

    var units = $('[data-ph-sa-units]', m);
    if (units) units.addEventListener('click', function (e) {
      var b = e.target.closest('button'); if (!b) return;
      unit = b.dataset.unit;
      $$('button', units).forEach(function (x) { x.classList.toggle('is-active', x === b); });
      $('[data-units-us]', m).hidden = unit !== 'us';
      $('[data-units-metric]', m).hidden = unit !== 'metric';
    });
    $$('[data-ph-sa-group]', m).forEach(function (g) {
      g.addEventListener('click', function (e) {
        var b = e.target.closest('.ph-sa__opt'); if (!b) return;
        $$('.ph-sa__opt', g).forEach(function (x) { x.classList.toggle('is-selected', x === b); });
        answers[g.dataset.phSaGroup] = b.dataset.value;
        err('');
        setTimeout(function () { next.click(); }, 180);
      });
    });

    function validate() {
      var s = steps[cur];
      if (cat === 'shoes' && cur === 0) {
        var v = $('[data-ph-sa-shoe]', m).value; if (!v) { err('Select your usual size to continue.'); return false; }
        answers.shoe = v; return true;
      }
      if (cat !== 'shoes' && cur === 0) {
        var hIn, lbs;
        if (unit === 'us') {
          var ft = parseFloat($('[data-ph-sa-ft]', m).value), inch = parseFloat($('[data-ph-sa-in]', m).value || 0);
          lbs = parseFloat($('[data-ph-sa-lbs]', m).value);
          if (!(ft >= 4 && ft <= 7) || !(inch >= 0 && inch < 12)) { err('Enter your height, e.g. 5 ft 6 in.'); return false; }
          hIn = ft * 12 + inch;
        } else {
          var cm = parseFloat($('[data-ph-sa-cm]', m).value), kg = parseFloat($('[data-ph-sa-kg]', m).value);
          if (!(cm >= 140 && cm <= 215)) { err('Enter your height in cm, e.g. 168.'); return false; }
          hIn = cm / 2.54; lbs = kg * 2.2046;
        }
        if (!(lbs >= 80 && lbs <= 400)) { err('Enter your weight to continue.'); return false; }
        answers.hIn = hIn; answers.lbs = lbs; return true;
      }
      var g = $('[data-ph-sa-group]', s);
      if (g && answers[g.dataset.phSaGroup] === undefined) { err('Choose one option to continue.'); return false; }
      return true;
    }

    function computeApparel() {
      var lbs = answers.lbs, h = answers.hIn, score;
      if (gender === 'men') {
        var mt = [130, 150, 172, 195, 220, 250, 280];
        score = 1; for (var i = 0; i < mt.length; i++) { if (lbs > mt[i]) score = i + 2; }
        if (h >= 73) score += 0.4; else if (h <= 66) score -= 0.3;
      } else {
        var wt = [105, 120, 137, 155, 176, 199, 225, 255];
        score = 0; for (var j = 0; j < wt.length; j++) { if (lbs > wt[j]) score = j + 1; }
        if (h >= 69) score += 0.4; else if (h <= 62) score -= 0.3;
      }
      var build = parseFloat(answers.build || 0), fit = parseFloat(answers.fit || 0), layer = parseFloat(answers.layer || 0);
      score += build > 0 ? 0.6 : (build < 0 ? -0.5 : 0);
      score += fit > 0 ? 0.5 : (fit < 0 ? -0.4 : 0);
      if (cat === 'outerwear') score += layer * 0.6;
      if (cat === 'dress' && build > 0) score += 0.2;
      var idx = Math.max(0, Math.min(ORDER.length - 1, Math.floor(score + 0.5)));
      var avail = sizes.map(norm);
      function nearest(k) {
        var best = null, bd = 99;
        avail.forEach(function (a, n) { var p = ORDER.indexOf(a); if (p < 0) return; var d = Math.abs(p - k) + (p < k ? 0.1 : 0); if (d < bd) { bd = d; best = n; } });
        return best;
      }
      var n = nearest(idx);
      if (n === null) return null;
      var up = nearest(Math.min(ORDER.length - 1, ORDER.indexOf(avail[n]) + 1));
      var fitTxt = { '-1': 'a close fit', '0': 'a true-to-size fit', '1': 'a relaxed fit' }[String(answers.fit || 0)];
      var hTxt = unit === 'us' ? Math.floor(h / 12) + "' " + Math.round(h % 12) + '"' : Math.round(h * 2.54) + ' cm';
      var wTxt = unit === 'us' ? Math.round(lbs) + ' lbs' : Math.round(lbs / 2.2046) + ' kg';
      var why = 'Based on ' + hTxt + ', ' + wTxt + ' and ' + fitTxt + '.';
      if (cat === 'outerwear') why += ' Our coats and jackets are cut with room for a light knit underneath.';
      if (cat === 'knit') why += ' Our knits are designed for an easy, comfortable drape.';
      return { value: sizes[n], alt: (up !== null && up !== n) ? 'Prefer more room or heavy layers? Choose ' + sizes[up] + '.' : '', why: why };
    }
    function computeShoes() {
      var base = parseFloat(answers.shoe); if (isNaN(base)) return { value: answers.shoe, why: '', alt: '' };
      var add = 0;
      if (answers.width === 'wide') add = 0.5; else if (answers.between === 'often') add = 0.5;
      var target = base + add, best = null, bd = 99;
      sizes.forEach(function (s) { var v = parseFloat(s); if (isNaN(v)) return; var d = v - target; var score = d < 0 ? Math.abs(d) + 0.3 : d; if (score < bd) { bd = score; best = s; } });
      var why = 'Based on your usual US ' + answers.shoe + (answers.width === 'wide' ? ' and a wider foot' : '') + '.';
      if (add) why += ' We recommend going half a size up for a comfortable fit.';
      else why += ' This style fits true to size.';
      return { value: best || answers.shoe, why: why, alt: answers.width === 'narrow' ? 'Narrow feet: your usual size with a thin insole works best.' : '' };
    }
    function showResult() {
      rec = cat === 'shoes' ? computeShoes() : computeApparel();
      if (!rec) { err('Sorry, we could not match a size. Please email us for personal advice.'); return; }
      steps.forEach(function (s) { s.classList.remove('is-active'); });
      result.classList.add('is-active'); nav.hidden = true; bar.style.width = '100%';
      $('[data-ph-sa-size]', m).textContent = rec.value;
      $('[data-ph-sa-size-label]', m).textContent = rec.value;
      $('[data-ph-sa-why]', m).textContent = rec.why;
      $('[data-ph-sa-alt]', m).textContent = rec.alt || '';
    }
    next.addEventListener('click', function () {
      if (!validate()) return;
      if (cur < steps.length - 1) go(cur + 1); else showResult();
    });
    back.addEventListener('click', function () { if (cur > 0) go(cur - 1); });
    $('[data-ph-sa-restart]', m).addEventListener('click', function () { answers = {}; $$('.ph-sa__opt', m).forEach(function (x) { x.classList.remove('is-selected'); }); go(0); });
    $('[data-ph-sa-add]', m).addEventListener('click', function () {
      if (!rec) return;
      var name = m.dataset.optionName, pos = m.dataset.optionPosition;
      var section = document.querySelector('.product-section') || document;
      var radios = $$('input[type="radio"][data-index="option' + pos + '"]', section);
      var target = radios.filter(function (r) { return r.value === String(rec.value); })[0];
      if (target) { target.checked = true; target.dispatchEvent(new Event('change', { bubbles: true })); var lbl = section.querySelector('label[for="' + target.id + '"]'); if (lbl) lbl.click(); }
      else {
        var sel = section.querySelector('select[data-index="option' + pos + '"]');
        if (sel) { sel.value = rec.value; sel.dispatchEvent(new Event('change', { bubbles: true })); }
      }
      close();
      setTimeout(function () { var btn = section.querySelector('[data-add-to-cart]'); if (btn && !btn.disabled) btn.click(); }, 250);
    });
    go(0);
  }

  /* ---------------- Cart drawer: tier progress + upsell ---------------- */
  var TIERS = [{ n: 2, p: 10 }, { n: 3, p: 15 }, { n: 4, p: 20 }];
  function renderTier(count) {
    $$('[data-ph-tier]').forEach(function (w) {
      var fill = $('.ph-tier__fill', w), msg = $('.ph-tier__msg', w);
      if (fill) fill.style.width = Math.min(100, (count / 4) * 100) + '%';
      $$('.ph-tier__node', w).forEach(function (n) { n.classList.toggle('is-reached', count >= parseInt(n.dataset.n, 10)); });
      var nextT = TIERS.filter(function (t) { return count < t.n; })[0];
      var have = TIERS.filter(function (t) { return count >= t.n; }).pop();
      if (!msg) return;
      if (!count) msg.innerHTML = 'Buy 2 items, save <strong>10%</strong> · 3 items <strong>15%</strong> · 4+ items <strong>20%</strong>';
      else if (nextT) msg.innerHTML = (have ? 'You’re saving <strong>' + have.p + '%</strong>. ' : '') + 'Add <strong>' + (nextT.n - count) + ' more item' + (nextT.n - count > 1 ? 's' : '') + '</strong> to save <strong>' + nextT.p + '%</strong>';
      else msg.innerHTML = 'Wonderful! You’re saving <strong>20%</strong> on your order';
    });
  }
  function refreshCart() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
      renderTier(c.item_count); loadUpsell(c);
    }).catch(function () {});
  }
  var upsellKey = '';
  function loadUpsell(cart) {
    var wrap = $('[data-ph-upsell]'), track = $('[data-ph-upsell-track]');
    if (!wrap || !track) return;
    if (!cart.items || !cart.items.length) { wrap.hidden = true; return; }
    var key = cart.items[0].product_id + ':' + cart.items.length;
    if (key === upsellKey) return; upsellKey = key;
    var ids = cart.items.map(function (i) { return i.product_id; });
    fetch('/recommendations/products.json?product_id=' + cart.items[0].product_id + '&limit=8&intent=complementary')
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var prods = (d.products || []).filter(function (p) { return ids.indexOf(p.id) === -1 && p.available; });
        if (prods.length < 2) return fetch('/recommendations/products.json?product_id=' + cart.items[0].product_id + '&limit=8').then(function (r) { return r.json(); }).then(function (d2) { return (d2.products || []).filter(function (p) { return ids.indexOf(p.id) === -1 && p.available; }); });
        return prods;
      })
      .then(function (prods) {
        if (!prods || !prods.length) { wrap.hidden = true; return; }
        track.innerHTML = '';
        prods.slice(0, 6).forEach(function (p) {
          var v = p.variants.filter(function (x) { return x.available; })[0] || p.variants[0];
          var el = document.createElement('div'); el.className = 'ph-upsell__card';
          var img = p.featured_image ? (p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=300') : '';
          el.innerHTML = '<a href="' + p.url + '">' + (img ? '<img loading="lazy" src="' + img + '" alt="">' : '<img alt="">') + '</a><div><div>' + p.title + '</div><div>' + money(p.price) + '</div>' +
            (p.variants.length > 1 ? '<a class="ph-link" style="margin-top:6px;font-size:10px" href="' + p.url + '">Choose size</a>' : '<button type="button" data-vid="' + v.id + '">Add</button>') + '</div>';
          track.appendChild(el);
        });
        wrap.hidden = false;
      }).catch(function () { wrap.hidden = true; });
  }
  function initCart() {
    if (!$('[data-ph-tier]')) return;
    refreshCart();
    ['ajaxProduct:added', 'cart:updated', 'cart:build', 'cartdrawer:opened'].forEach(function (ev) { document.addEventListener(ev, function () { setTimeout(refreshCart, 350); }); });
    var prod = $('#CartDrawer [data-products]');
    if (prod && window.MutationObserver) new MutationObserver(function () { setTimeout(refreshCart, 150); }).observe(prod, { childList: true });
    document.addEventListener('click', function (e) {
      var b = e.target.closest('.ph-upsell__card button[data-vid]'); if (!b) return;
      b.disabled = true; b.textContent = '…';
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: b.dataset.vid, quantity: 1 }) })
        .then(function () { b.textContent = 'Added'; upsellKey = ''; document.dispatchEvent(new CustomEvent('cart:build')); setTimeout(refreshCart, 300); })
        .catch(function () { b.disabled = false; b.textContent = 'Add'; });
    });
    /* Remove + quantity buttons rendered by cart-item */
    document.addEventListener('click', function (e) {
      var rm = e.target.closest('.cart__remove-btn');
      if (rm) {
        e.preventDefault();
        fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: rm.dataset.removeKey, quantity: 0 }) })
          .then(function () { document.dispatchEvent(new CustomEvent('cart:build')); setTimeout(refreshCart, 300); });
        return;
      }
      var q = e.target.closest('.cqty-ui__btn'); if (!q) return;
      var ui = q.closest('.cqty-ui'), key = ui.dataset.qtyKey, num = $('.cqty-ui__num', ui);
      var nextQ = Math.max(0, (parseInt(num.textContent, 10) || 1) + (q.classList.contains('cqty-ui__btn--minus') ? -1 : 1));
      num.textContent = nextQ;
      fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: key, quantity: nextQ }) })
        .then(function () { document.dispatchEvent(new CustomEvent('cart:build')); setTimeout(refreshCart, 300); });
    });
  }

  function init() { initDelivery(); initHero(); initFaq(); initSizeAssistant(); initCart(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function () { initHero(); initFaq(); initDelivery(); });
})();
